import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import bg1 from '../../assets/images/b3.png'
import sponsorLogo from '../../assets/images/efi.png'


export default class About extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        // list all tags
        // pick three
        // show 3 options
        // on click generate tag tour
    }

    render() {
        return (
            <div className="about">
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>About</h1>
                </div>
                <h2>About A Poetry Mile</h2>
                <p>A Poetry Mile: Poetry Walking Tours is a series of bespoke poetry walks which encourage users to experience their city differently, filtered through the eyes and ears of some of our finest poets. We’ve commissioned this project as part of Push the Boat Out: Edinburgh’s International Poetry Festival, but the project will go on much longer than the first festival—the app will be available from 1 October 2021 for a full year. </p>
                <p>Our concept is fairly simple: Every user gets a walking route individually generated according to their preferences, and is presented a bespoke series of poems which accompany the walker on their custom-created map. Most of the poems are associated with locations within a square mile of Summerhall Arts Centre, but some have (excitingly!) escaped the confines of our Poetry Mile. We’re hoping that this project will further expand for future festival iterations. </p>
                <p>You can choose from randomly generated ‘themed walks’ – these have been filtered with environment/surrounding, theme/content, and tone/mood tags associated by the poets – and curated walks, which the PTBO team has put together for you. You can also filter results to a single poet, or go to the Poem Map in our library and see every recording you have to choose from! We of course encourage you to explore the spaces chosen by our poets with your own feet or wheels, but the app is also fully accessible online. If you’re not in Edinburgh or are planning on visiting, A Poetry Mile is a great way to introduce yourself to the personality and personalisation possible in the city.  </p>
                <p>Our view is that encounters with poetry – and any artform – can change, deepen and elevate your perception of even the most mundane or everyday of experiences and places. These are the primary intentions of the project. We want to offer new perspectives on our city, to commission new work exploring the personal experiences of our artists and their resonances with place, and to continue the centuries-old tradition of weaving literature into the fabric of our capital city, in an entirely contemporary way. Our hope is that A Poetry Mile speaks to residents and visitors alike. </p>
                <p>A Poetry Mile is made possible by the generous support of James and Morag Anderson, and the Edinburgh Futures Institute at The University of Edinburgh  </p>
                <img style={{ 'max-width': '100%'}} src={sponsorLogo} />
            </div>
        );
    }
}
